import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useAbility } from '../modules/users/AbilityContext';
import { ResourceType } from '../modules/users/ability.types';
import Clarity from './clarity/components/Clarity';

export interface SecureRouteProps extends RouteProps {
  name: ResourceType;
  disabled?: boolean;
  path: string;
  validateAbility?: boolean;
}

const SecureRoute = ({
  name,
  disabled = false,
  render,
  component: Component,
  validateAbility = true,
  ...props
}: SecureRouteProps) => {
  const ability = useAbility();

  const redirectByAbility = validateAbility && ability.cannot('menu', name);

  if (disabled || redirectByAbility) {
    return <Redirect to="/" />;
  }

  return (
    <Route
      {...props}
      render={(renderProps) => (
        <>
          <Clarity name={name} path={props.path} />
          {render && render(renderProps)}
          {Component && <Component {...renderProps} />}
        </>
      )}
    />
  );
};

export default SecureRoute;
